import { observable } from "mobx";
import lscache from 'lscache';
import ControleEstoqueService from './../../../../services/ControleEstoqueService';

export default class CamposEstoqueStore {

    @observable todosCampos;
    @observable camposAtivos;
    @observable todosCamposIds;
    @observable camposObrigatorios;

    @observable filtrosSalvos
    @observable filtroSelecionado
    @observable filtrosVisualizacao
    @observable filtrosAntigos

    @observable filtroNomeAnterior
    @observable filtroDescAnterior
    @observable mostrarEditarFiltroNome

    filtroAnterior
    qtdAtivos

    constructor() {
        this.todosCampos = [];
        this.camposAtivos = [];
        this.todosCamposIds = [];
        this.camposObrigatorios = [];

        this.qtdAtivos = this.camposObrigatorios.length;

        this.filtrosVisualizacao = [];
        this.filtrosAntigos = [];
        this.filtrosSalvos = [];
        this.filtroSelecionado = 0;

        this.service = new ControleEstoqueService();
        this.mostrarEditarFiltroNome = false;

        this.carregarCampos();
        this.carregarPerfis();
    }

    carregarCampos = () => {
        this.service.ListarCamposExib().then(response => {
            if(response.data) {
                this.todosCampos = response.data.map(campo => ({id: campo.Codigo, label: campo.Descr}));
            };
        });
        // this.todosCampos = this.camposMock.map(campo => ({id: campo.Codigo, label: campo.Descr}));
        // this.todosCamposIds = this.camposMock.map(campo => campo.Codigo);
    }
    
    carregarPerfis = () => {
        this.filtroSelecionado = 0;
        // this.filtrosSalvos = this.filtrosVisualizacao && [JSON.parse(this.filtrosVisualizacao[0].ValorObjeto),JSON.parse(this.filtrosVisualizacao[1].ValorObjeto)];
        // this.camposAtivos = this.filtrosVisualizacao && JSON.parse(this.filtrosVisualizacao[0].ValorObjeto).dadosTabela;
        this.service.ListarFiltros().then(response => {
            if(response.data) {
                response.data.map(data => {
                    // nada
                });
                this.filtrosAntigos = response.data
                this.filtrosVisualizacao = response.data
                
                if (this.filtrosVisualizacao.length){
                    //carrega os filtros já salvos
        
                    //procura o filtro selecionado
        
                    this.filtrosVisualizacao.find((elem, index) => {
                        const parsed = JSON.parse(elem.ValorObjeto)
                        
                        if(parsed.valor === 1){
                            this.filtroSelecionado = index
                            return index
                        }else{
                            this.filtroSelecionado = 0
                            return 0
                        }
                    })
        
                    this.filtrosSalvos = []
        
                    this.filtrosVisualizacao.forEach(f => {
                        this.filtrosSalvos.push(JSON.parse(f.ValorObjeto))
                    })
                    
                    
                    if(this.filtrosSalvos.indexOf(this.filtrosSalvos.find((elem) => elem.valor === 1)) === -1){
                        this.filtroSelecionado = 0
                    }else{
                        this.filtroSelecionado = this.filtrosSalvos.indexOf(this.filtrosSalvos.find((elem) => elem.valor === 1))
                    }
                    
                    this.camposAtivos = this.filtrosSalvos[this.filtroSelecionado].dadosTabela
        
                }else{
                    //Se não há filtros, então crie um novo filtro default
                    this.filtrosSalvos = []
                    let i = this.filtrosVisualizacao.length
                    for(i; i < 3;i++){
                        this.filtrosVisualizacao[i] = this.service.novoFiltro
                        this.filtrosVisualizacao[i].MembershipuserId = lscache.get('MembershipuserId')
                        this.filtrosVisualizacao[i].ValorObjeto = this.service.novoValor
                        
                    }   
                    
                    
                    const novoFiltro = this.service.novoValor
                    this.camposAtivos = novoFiltro.dadosTabela
                    
                    this.filtrosVisualizacao.forEach(f => {
                        this.filtrosSalvos.push(f.ValorObjeto)
                    })
                    this.calculaQtdAtivos()
                }
            };
        }).catch(err => console.error(err));
    }

    clickFiltro = (index) => {
        this.filtroSelecionado = index
        this.camposAtivos = this.filtrosSalvos[this.filtroSelecionado].dadosTabela

        this.calculaQtdAtivos()
    }

    clickCheckboxCampo = (index) => {
        let indexCampoChecked = this.camposAtivos.indexOf(this.camposAtivos.find((item) => item === index.id));

        if(indexCampoChecked !== -1){
            this.camposAtivos = this.camposAtivos.filter((value, i) => i !== indexCampoChecked);
        } else {
            this.camposAtivos.push(index.id);
        }

        this.filtrosSalvos[this.filtroSelecionado].dadosTabela = this.camposAtivos
        this.calculaQtdAtivos()
    }

    selecionarTodosOsCampos = () => {
        this.camposAtivos = this.todosCamposIds;
        this.filtrosSalvos[this.filtroSelecionado].dadosTabela = this.camposAtivos
        this.calculaQtdAtivos()
    }

    limparTodosOsCampos = () => {
        this.camposAtivos = [...this.camposObrigatorios];
        this.filtrosSalvos[this.filtroSelecionado].dadosTabela = this.camposAtivos
        this.calculaQtdAtivos()
    }

    calculaQtdAtivos = () => {
        this.qtdAtivos = this.camposAtivos.length;
    }

    salvarFiltro = () => {

        this.filtrosVisualizacao.map((elem,index) => {
            elem.NomeObjeto = ""
            if(index === this.filtroSelecionado){
                this.filtrosSalvos[index].valor = 1
            }else{
                this.filtrosSalvos[index].valor = 0

            }
            elem.ValorObjeto = JSON.stringify(this.filtrosSalvos[index])
            elem.DataUltimaModificacao = null;
            this.service.SalvarFiltro(elem)
                .then(data => {
                    //console.log('filtro salvo')
                })
                .catch(err => console.log(err))
        })
        // Como quando salva fecha a tela, eu tenho que ter alguma forma de resetar esse valor
        this.carregarCampos()
    }

    editarFiltroNomeClick = () => {
        this.filtroNomeAnterior = this.filtrosSalvos[this.filtroSelecionado].nome
        this.filtroDescAnterior = this.filtrosSalvos[this.filtroSelecionado].descricao
        this.mostrarEditarFiltroNome = true
    }

    salvarNovoNome = () => {
        this.mostrarEditarFiltroNome = false
    }

    cancelarNovoNome = () => {
        this.filtrosSalvos[this.filtroSelecionado].nome = this.filtroNomeAnterior
        this.filtrosSalvos[this.filtroSelecionado].descricao = this.filtroDescAnterior
        this.mostrarEditarFiltroNome = false
    }

    mudarNomePred = (e) => { this.filtrosSalvos[this.filtroSelecionado].nome = e.target.value }

    mudarDescPred = (e) => { this.filtrosSalvos[this.filtroSelecionado].descricao = e.target.value }


    sairModalLimite = () => { this.limiteCamposAtingido = false }

    cancerlarFiltros = () => {
        this.filtrosVisualizacao = this.filtrosAntigos
        this.carregarCampos()
    }

    // perfisMock = [
    //     {
    //         ApplicationId: 64,
    //         DataUltimaModificação: "2020-03-16T14:32:13",
    //         DescricaoObjeto: "Filtro Movimentação",
    //         Id: 25,
    //         MembershipuserId: 325,
    //         NomeObjeto: null,
    //         OperationId: 1,
    //         TaskId: 2,
    //         TipoObjeto: "FILTRO",
    //         ValorObjeto: "{\"valor\": 1, \"nome\":\"Padrão\", \"descricao\":\"Desc\",\"dadosTabela\":[\"Armador\",\"Cliente\",\"Cntr\"]}"
    //     },
    //     {
    //         ApplicationId: 65,
    //         DataUltimaModificação: "2020-03-16T14:32:14",
    //         DescricaoObjeto: "Filtro Movimentação",
    //         Id: 26,
    //         MembershipuserId: 325,
    //         NomeObjeto: null,
    //         OperationId: 1,
    //         TaskId: 2,
    //         TipoObjeto: "FILTRO",
    //         ValorObjeto: "{\"valor\": 2, \"nome\":\"Padrão2\", \"descricao\":\"Desc2\",\"dadosTabela\":[\"Armador\"]}"
    //     }
    // ]

    // camposMock = [
    //     {
    //         Codigo:"Armador",
    //         Descr: "Armador",
    //         Enabled: true,
    //         Selected: true
    //     },
    //     {
    //         Codigo:"Cliente",
    //         Descr: "Cliente",
    //         Enabled: true,
    //         Selected: true
    //     },
    //     {
    //         Codigo:"Cntr",
    //         Descr: "Container",
    //         Enabled: true,
    //         Selected: true
    //     },
    //     {
    //         Codigo:"Documento",
    //         Descr: "Documento",
    //         Enabled: true,
    //         Selected: true
    //     },
    //     {
    //         Codigo:"DatEntrada",
    //         Descr: "Data Entrada",
    //         Enabled: true,
    //         Selected: true
    //     },
    //     {
    //         Codigo:"DatDesova",
    //         Descr: "Data Desova",
    //         Enabled: true,
    //         Selected: true
    //     },
    //     {
    //         Codigo:"Teste",
    //         Descr: "Teste",
    //         Enabled: true,
    //         Selected: true
    //     }
    // ]
}


// WEBPACK FOOTER //
// ./src/modules/consultas/estoque/stores/CamposEstoqueStore.js